import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {SortDirectionIcon} from '../../icons/sort-direction-icon';

export const SortingIndicator = ({color, sorted, direction}) => {
	return (
		<Container>
			<SortDirectionIcon
				color={!sorted || direction === 'ASC' ? color : '#d3d3d3'}
				updated
				direction={SortDirectionIcon.DIRECTION.UP}
			/>
			<SortDirectionIcon
				color={!sorted || direction === 'DESC' ? color : '#d3d3d3'}
				updated
				direction={SortDirectionIcon.DIRECTION.DOWN}
			/>
		</Container>
	);
};

SortingIndicator.propTypes = {
	color: PropTypes.string,
	sorted: PropTypes.bool,
	direction: PropTypes.string,
};

const Container = Styled.div`
    display: flex;
    color: inherit;
    flex-direction: column;
    justify-content: space-between;
    height: 14px;
`;
